export class AmountTable {
    constructor(options = {}) {
        this.el = null;
        if (options.element) {
            this.el = options.element;
        } else if (options.componentId) {
            this.el = window[options.componentId];
        }

        this.templateEl = null;
        this.templateSelector = options.templateSelector;
        if (this.el) {
            const templateEl = this.el.querySelector('[data-template="store"]');
            this.templateEl = templateEl?.content?.firstElementChild;
        }
        if (!this.templateEl && this.templateSelector) {
            const templateEl = document.querySelector(this.templateSelector);
            this.templateEl = templateEl?.content?.firstElementChild;
        }

        this.productId = options.productId;
        this.offerId = options.offerId;
        this.isLazy = options.isLazy;   // Работает с ленивой загрузкой
        this.isLazyLoaded = false;      // Выполнена ленивая загрузка
        this.isLoaded = !this.isLazy;   // Данные загружены (предотвращает повторную загрузку данных при смене таба)
        this.isLoading = false;         // Выполнение запроса в текущий момент

        this.errors = null;
        this.emptyMessage = options.emptyMessage;

        if (options.lazyClickSelector) {
            document.querySelectorAll(options.lazyClickSelector)
                .forEach((el) => {
                    el.addEventListener('click', this.onLazyLoad.bind(this));
                });
        }

        this.subscribeOnProduct();
    }

    async subscribeOnProduct() {
        const product = await BX.Asteq.Catalog.Product.getInstanceAsync(this.productId);
        if (!product) {
            return;
        }

        product.subscribe('offerChange', this.onProductOfferChange.bind(this));
    }

    setOfferId(offerId) {
        this.offerId = offerId;
        this.isLoaded = false;

        if (!this.isLazy || this.isLazy && this.isLazyLoaded) {
            this.loadStores();
        }
    }

    getLoadedId() {
        return this.offerId ?? this.productId;
    }

    displayErrros() {
        if (!this.el) {
            return;
        }

        const message = '<div style="color: red;">Во время загрузки произошла ошибка: ' + this.errors[0].message + '</div>';
        this.el.innerHTML = message;
    }

    displayMessage(message) {
        if (!this.el) {
            return;
        }

        this.el.innerHTML = `<div class="stores-availability-list_message">${message}</div>`;
    }

    displayStores(stores) {
        if (!this.el || !this.templateEl) {
            return;
        }

        const storesEls = [];
        for (const store of stores) {
            const storeTpl = this.templateEl.cloneNode(true);
            const dataInfoEl = storeTpl.querySelector('[data-info]');
            if (dataInfoEl) {
                dataInfoEl.innerHTML = store.TITLE;
            }

            const amountEl = storeTpl.querySelector('[data-amount]');
            if (amountEl) {
                if (store.STATUS_CLASSES?.length) {
                    store.STATUS_CLASSES.forEach((cls) => {
                        amountEl.classList.add(cls);
                    });
                }

                const amountTitleEl = amountEl.querySelector('[data-amount-title]');
                if (amountTitleEl) {
                    amountTitleEl.innerHTML = store.STATUS_TITLE;
                }
            }

            storesEls.push(storeTpl);
        }

        this.el.innerHTML = '';

        storesEls.forEach((el) => {
            this.el.appendChild(el);
        });
    }

    setLoading(value) {
        this.isLoading = value;
        if (this.el) {
            if (this.isLoading) {
                this.el.classList.add('form-sending');
            } else {
                this.el.classList.remove('form-sending');
            }
        }
    }

    loadStores() {
        if (this.isLoading || this.isLoaded) {
            return;
        }

        this.setLoading(true);

        BX.ajax.runComponentAction('moto:stores.availability', 'getStores', {
            mode: 'class',
            data: {
                productId: this.getLoadedId(),
            },
        }).then((response) => {
            this.isLoaded = true;
            const stores = response.data.stores;
            if (stores) {
                this.displayStores(stores);
            } else if (response.data.message && !this.emptyMessage) {
                this.displayMessage(response.data.message);
            } else if(this.emptyMessage) {
                this.displayMessage(this.emptyMessage);
            }

            this.errors = null;

            this.setLoading(false);

        }, (response) => {
            this.errors = response.errors;
            this.setLoading(false);
            this.displayErrros();

        });
    }

    onLazyLoad() {
        if (!this.isLoaded) {
            this.isLazyLoaded = true;
            this.loadStores();
        }
    }

    onProductOfferChange(e) {
        const eventData = e.getData();
        this.setOfferId(eventData.newOffer?.id);
    }
}